export const userPermissions = {
  admin: 'admin',
  user: 'user',
};
